import { type ReactNode, useCallback } from 'react'

import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { removeSpecialCharacters } from 'commons/utils/string'
import { CopyButton, SlimButton } from 'components'
import { theme } from 'styles/theme/hav-theme'

import { ContentTooltip } from '../ContentTooltip'
import * as S from './styles'

interface SendMessageTooltipProps {
  name: string
  email: string
  phone?: string
  children: ReactNode
}

export const SendMessageTooltip = ({ name, email, phone, children }: SendMessageTooltipProps) => {
  const normalizedPhone = phone ? removeSpecialCharacters(phone).replace(/\s+/g, '').trim() : ''
  const whatsappWebLink = `https://web.whatsapp.com/send?phone=${normalizedPhone}`

  const handleOpenWhatsappWeb = useCallback(() => {
    window.open(whatsappWebLink, '_blank')
  }, [])

  return (
    <ContentTooltip
      content={
        <S.Container>
          <S.NameText>{name}</S.NameText>
          <S.EmailContainer>
            <S.EmailText>{email}</S.EmailText>
            <CopyButton text={email} />
          </S.EmailContainer>
          {!!phone && (
            <>
              <S.Divider />
              <S.ButtonContainer>
                <SlimButton
                  content="Enviar mensagem"
                  height={28}
                  icon={<WhatsAppIcon sx={{ fontSize: theme.typography.sizes.sm }} />}
                  onClick={handleOpenWhatsappWeb}
                  variant="info"
                />
              </S.ButtonContainer>
            </>
          )}
        </S.Container>
      }
    >
      {children}
    </ContentTooltip>
  )
}
